module.exports = __webpack_public_path__ + "nc_static/media/file-doc.9141c9d3.svg";